import Alert from "@mui/material/Alert";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Cookies from "js-cookie";
import React from "react";
import {useTranslation} from "react-i18next";

import {useNavigate} from "react-router-dom";
import {useAuth} from "../../context/AuthContext";
import {upsertUser} from "../../services/requests/ApiRequests";
import {validateUserNew} from "../../services/Validations";

const AddAdmin = () => {
	const {t} = useTranslation();


	const {firstAdmin, refresh} = useAuth();

	const navigate = useNavigate();


	const [user, setUser] = React.useState({
		login: '',
		password: '',
		email: '',
		role: 1,
		status: 1,
		organization_id: 1,
		cash_register_ids: [],
	});


	const [readyToSave, setReadyToSave] = React.useState(false);

	const [formValidationError, setFormValidationError] = React.useState({
		login: true,
		password: true,
		email: true,
		role: true,
		status: true,
		organization_id: true,
		cash_register_ids: true,
	});

	const [success, setSuccess] = React.useState({
		status: false,
		msg: "Error",
	});

	const [error, setError] = React.useState({
		status: false,
		msg: "Error",
	});


	React.useEffect(() => {
		let validateResult = validateUserNew(user);

		setReadyToSave(validateResult.validation);
		setFormValidationError(validateResult.errors);
	}, [user]);

	if (firstAdmin) {
		navigate("/");
	}

	const handleChange = (event) => {
		setUser(prevState => ({
			...prevState,
			[event.target.name]: event.target.value,
		}));
	};

	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		setSuccess({
			status: false,
			msg: "",
		});
		setError({
			status: false,
			msg: "Error",
		});
	};


	function handleUpsertUser() {
		upsertUser({
			...user,
			cash_register_ids: [],
			password: user.password === 0 ? '' : user.password,
		})
			.then((data) => {
				if (!data.data.success) {
					setError({
						status: true,
						msg: "There are errors while receipt generation",
					});
					return;
				}
				setSuccess({
					status: true,
					msg: "success_create_user",
				});
				// Set cookie to indicate first admin was created
				Cookies.set("first_admin_created", "true");
				refresh()
				navigate('/')
			})
			.catch((error) => {
				console.log(error);
				setError({
					status: true,
					msg: `${error}`,
				});
			});
	}

	return (
		<Box
			sx={{
				width: "100%",
				height: "90%",
				position: "absolute",
				marginTop: 9,
			}}
		>
			<Box
				sx={{flexGrow: 1, marginTop: 3, marginLeft: 10, marginBottom: 10}}
			>
				<Grid container sx={{marginTop: 2}} spacing={4} align="left">
					<Grid item xs={6}>
						<Typography
							sx={{fontSize: 24}}
							color="pimary"
							gutterBottom
						>
							{t('register_admin')}
						</Typography>
					</Grid>
					<Grid item xs={5} align="right"
					      sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, alignItems: 'center'}}>
						<Button
							variant="outlined"
							disabled={!readyToSave}
							onClick={handleUpsertUser}
						>
							{t('save_user')}
						</Button>
					</Grid>

					<Grid container sx={{marginTop: 2}} direction={'row'} spacing={4}>
						<Grid item xs={6} sx={{display: 'flex', flexDirection: 'column', gap: 4, width: '100%'}}>
							<TextField
								error={formValidationError.login}
								name={'login'}
								value={user.login}
								onChange={handleChange}
								variant={"standard"}
								label={t('login')}
								required
								fullWidth
							/>
							<TextField
								error={formValidationError.email}
								name={'email'}
								value={user.email}
								onChange={handleChange}
								variant={"standard"}
								label={t('email')}
								type={'email'}
								required
								fullWidth
							/>


						</Grid>
						<Grid item xs={6} sx={{display: 'flex', flexDirection: 'column', gap: 4, width: '100%'}}>
							<TextField
								error={formValidationError.password}
								name={'password'}
								value={user.password === 0 ? '' : user.password}
								InputProps={{readOnly: user.password === 0}}
								onChange={handleChange}
								variant={"standard"}
								label={t('password')}
								required
								fullWidth
							/>

						</Grid>

					</Grid>
					<Grid item xs={12} align="left" sx={{marginTop: 2}}>
						{t('note_mandatory_fields')}
					</Grid>
					<Alert sx={{marginTop: 4}} severity="info">{t("alert_add_admin")}</Alert>

				</Grid>
				<Snackbar
					open={success.status}
					autoHideDuration={6000}
					onClose={handleClose}
				>
					<Alert
						onClose={handleClose}
						severity="success"
						sx={{width: "100%"}}
					>
						{success.msg && t(success.msg)}
					</Alert>
				</Snackbar>
				<Snackbar
					open={error.status}
					autoHideDuration={6000}
					onClose={handleClose}
				>
					<Alert
						onClose={handleClose}
						severity="error"
						sx={{width: "100%"}}
					>
						{error.msg}
					</Alert>
				</Snackbar>
			</Box>
		</Box>
	);
}

export default AddAdmin;
